import React, { ChangeEvent, ReactNode, Fragment } from "react";
import {
  BaseTextFieldProps,
  Stack,
  TextField,
  styled,
  Typography,
  Slider,
} from "@mui/material";
import { MuiStyledWrapper, SliderWrapper } from "./MuiTextArea.style";
import ImageAssets from "../../../assets";

export interface IMuiTextFieldProps extends BaseTextFieldProps {
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  InputProps?: { [key: string]: ReactNode };
  label: string;
  type?: string;
  maxLength?: number;
  name: string;
  isErrorThere?: boolean;
  isShowSlider?: boolean;
  isBorderNotNeeded?: boolean;
  maxRows?: any;
  rows?: any;
}

const Item = styled("div") <any>`
  margin-top: 0px !important;
  padding: ${({ theme }) => theme.spacing(0.5)};
  text-align: "center";
  color: var(--white-color);
`;
const Wrapper = styled("div") <any>`
  .error-message-container {
    position: absolute;
    font-size: 1.6rem;
  }

  @media screen and (max-width: 376px) {
    .error-message-container {
      position: relative !important;
    }
  }
`;
const MuiTextArea = (props: any) => {
  const { maxLength, isShowSlider, placeholder, rows, maxRows } = props;

  const SliderComp = (props: any) => {
    return (
      <SliderWrapper
        value={props?.value?.length}
        maxLength={props?.max}
        isErrorThere={props?.isErrorThere}
      >
        <Slider
          value={props?.value?.length}
          min={1}
          step={0}
          max={props?.max}
          valueLabelDisplay="auto"
          aria-labelledby="non-linear-slider"
          size="medium"
        />
      </SliderWrapper>
    );
  };

  return (
    <Fragment>
      <MuiStyledWrapper
        isBorderNotNeeded={props?.isBorderNotNeeded}
        value={props.value}
        isErrorThere={props.errorMessage !== ""}
      >
        <TextField
          autoComplete={"off"}
          multiline
          rows={rows ? rows : 4}
          maxRows={maxRows ? maxRows : 4}
          size="medium"
          placeholder={placeholder}
          inputProps={{ maxLength: maxLength ? maxLength : "" }}
          sx={{
            "& .MuiOutlinedInput-root.Mui-disabled": {
              "& .MuiInputBase-input": {
                color: '#4e5567', // Changes the input text color
                WebkitTextFillColor: '#4e5567', // Ensures color applies in Webkit browsers
              },
            },
            "& .MuiInputLabel-root.Mui-disabled": {
              color: 'white', // Changes the label color
            },
            "& .Mui-disabled .MuiOutlinedInput-notchedOutline": {
              borderColor: '#576078 !important', // Changes the border color
            },
          }}
          {...props}
        />
        {!isShowSlider ? (
          <SliderComp
            value={props.value}
            max={props.maxLength}
            isErrorThere={props.errorMessage !== ""}
          />
        ) : (
          ""
        )}
        <Wrapper>
          {props.errorMessage !== "" ? (
            <Stack
              data-testid="error-message"
              className="error-message-container"
              flexDirection={"row"}
              alignItems={"center"}
              spacing={0.5}
              sx={{ background: "none" }}
            >
              <Item>
                <img alt="error" src={ImageAssets.ic_error_info} />
              </Item>
              <Item>
                <Typography className="input-error">
                  {props.errorMessage}
                </Typography>
              </Item>
            </Stack>
          ) : null}
        </Wrapper>
      </MuiStyledWrapper>
    </Fragment>
  );
};

export { MuiTextArea };
